import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export default function YoutubeIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      width: t1,
      height: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const width = t1 === undefined ? 28 : t1;
  const height = t2 === undefined ? 28 : t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M14 28C6.28 28 0 21.72 0 14S6.28 0 14 0s14 6.28 14 14-6.28 14-14 14zM14 .95C6.805.95.95 6.805.95 14S6.805 27.05 14 27.05 27.05 21.195 27.05 14 21.195.95 14 .95z" fill="#000" />;
    t4 = <path d="M22.516 11.197c-.106-1.027-.335-2.163-1.178-2.76-.653-.462-1.511-.48-2.312-.479l-5.082.004-4.887.005c-.68.001-1.342-.052-1.974.242-.543.253-.967.734-1.223 1.27-.354.743-.429 1.586-.471 2.41a39.041 39.041 0 00.023 4.498c.07 1.093.246 2.301 1.09 2.998.75.617 1.806.647 2.777.648l9.252.008c.395 0 .807-.007 1.21-.05.793-.086 1.548-.313 2.058-.9.514-.593.646-1.417.724-2.197.19-1.893.188-3.804-.007-5.697zm-10.355 5.457v-5.308l4.596 2.653-4.596 2.655z" fill="#000" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== height || $[7] !== props || $[8] !== width) {
    t5 = <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t3}{t4}</svg>;
    $[6] = height;
    $[7] = props;
    $[8] = width;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}